import React, { useState, useEffect } from 'react';
import { Form, message, Tabs, Modal, Button, Space } from 'antd';
import { useLocation } from 'react-router';
import FileServices from '../../services/FileServices';
import config from '../../config';
import axios from '../../axios';
import { usePersistedStore } from '../../store/persisted-store';
import { useGeneralStore } from '../../store/slices/createGeneralSlice';
import { validateUploadedFile } from '../../utils/fileSecurityValidator';
import BusinessSettings from './BusinessSettings';
import BusinessUploads from './BusinessUploads';
import BusinessStyles from './BusinessStyles';

export default function BusinessForm({ business, onSubmit, showInfoItems }) {
    const { TabPane } = Tabs;

    const general = useGeneralStore()
    const location = useLocation();
    const [form] = Form.useForm();
    const { auth, putBusiness } = usePersistedStore();
    const { NotifSuccess } = general;
    const userToken = auth.userToken;
    const [tabId, setTabId] = useState("1");
    const [Styles, setStyles] = useState(null);
    const [tabState, setTabState] = useState('');
    const [copyrightState, setCopyrightState] = useState(false);
    const [roundBulletInDesktop, setRoundBulletInDesktop] = useState();
    const [roundBulletInMobile, setRoundBulletInMobile] = useState();
    const [bulletOutlineInDesktop, setBulletOutlineInDesktop] = useState();
    const [bulletOutlineInMobile, setBulletOutlineInMobile] = useState();
    const [bulletTextOutInDesktop, setBulletTextOutInDesktop] = useState();
    const [bulletTextOutInMobile, setBulletTextOutInMobile] = useState();
    const [backgroundName, setBackgroundName] = useState();
    const [desktopBannerName, setDesktopBannerName] = useState();
    const [tabletBannerName, setTabletBannerName] = useState();
    const [mobileBannerName, setMobileBannerName] = useState();
    const [mainLogoName, setMainLogoName] = useState();
    const [faviconeName, setFaviconeName] = useState();
    const [footerLogoName, setFooterLogoName] = useState();
    const [ColorPickerStatus, setColorPickerStatus] = useState("");
    const [currentLocation, setCurrentLocation] = useState(false);
    const [businessId, setBusinessId] = useState(null);
    const [hasDefaultSlider, setHasDefaultSlider] = useState()
    const [htmlDisable, setHtmlDisable] = useState(business?.footerHtml ? false : true);
    const [textDisable, setTextDisable] = useState(business?.footerHtml ? true : false);
    const [uploadLoading, setUploadLoading] = useState(false);
    const [pendingUpload, setPendingUpload] = useState(null);
    const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(false);
    const userResources = auth?.userInfo?.Resources;

    const alignmentItems = [
        { id: 0, title: "راست چین", value: 1 },
        { id: 1, title: "وسط چین", value: 2 },
        { id: 2, title: "چپ چین", value: 3 },
    ]
    const aElementDownloadItems = [
        { id: 0, title: "دانلود عادی", value: 0 },
        { id: 1, title: "نمایش در تب جدید", value: 1 },
        { id: 2, title: "دانلود با سرویس JSON", value: 2 },
    ]
    const homeStyleItems = [
        { id: 0, title: "هوم بیمه دات کام", value: 1 },
        { id: 1, title: "هوم اول وایت لیبل ها ( پیش فرض )", value: 2 },
        { id: 2, title: "هوم دوم وایت لیبل ها", value: 3 },
        { id: 3, title: "هوم اپلیکیشن", value: 4 },
    ]
    const onChangeTab = (key) => {
        setTabId(key);
    }

    async function deleteBannerFiles(name, sub) {
        await FileServices.deleteFile(name, sub, business?.token).then(async (res) => {
            if (res) {

                (NotifSuccess('فایل با موفقیت حذف شد.'))
                await putBusiness({ desktopBanner: res.data.Url, id: business?.id, domain: business?.domain });
            }
        }).catch(error => {
            message.error(`${error.message} : خطا در حذف فایل`);
        })
    }


    const deleteMainFiles = async (fileName, folder) => {
        await axios({
            method: "delete",
            baseURL: config.apiUrls(),
            url: `/v1/business/Image/${folder}/${business?.token}`,
            headers: { Authorization: `Bearer ${userToken}`, "Content-Type": "multipart/form-data" },
        }).then(async (res) => {
            if (res?.status === 200) {
                switch (fileName) {
                    case 'mainlogo':
                        setMainLogoName('');
                        break;
                    case 'favicon':
                        setFaviconeName('');
                        break;
                    case 'background':
                        setBackgroundName('');
                        break;
                    case 'footerlogo':
                        setFooterLogoName('');
                        break;
                    default:
                        break;
                }
                message.success(`حذف با موفقیت انجام شد`);
                await putBusiness({ desktopBanner: res.data.Url, id: business?.id, domain: business?.domain });
            }
        }).catch((error) => {
            message.error(`خطا در حذف فایل`);
        })
    }

    useEffect(() => {
        setTabId("1")
        setHtmlDisable(business?.footerHtml ? false : true)
        setTextDisable(business?.footerHtml ? true : false)
        if (business?.outlineBulletInDesktop) { setBulletOutlineInDesktop(true) }
        if (business?.outlineBulletInMobile) { setBulletOutlineInMobile(true) }
        if (business?.bulletTextOutInDesktop) { setBulletTextOutInDesktop(true) }
        if (business?.bulletTextOutInMobile) { setBulletTextOutInMobile(true) }
        if (business?.roundBulletInDesktop) { setRoundBulletInDesktop(true); setBulletTextOutInDesktop(true); setBulletOutlineInDesktop(false) }
        if (business?.roundBulletInMobile) { setRoundBulletInMobile(true); setBulletTextOutInMobile(true); setBulletOutlineInMobile(false) }
        business?.sliderImage ? setBackgroundName(business?.sliderImage) : setBackgroundName('')
        business?.desktopBanner ? setDesktopBannerName(business?.desktopBanner) : setDesktopBannerName('')
        business?.tabletBanner ? setTabletBannerName(business?.tabletBanner) : setTabletBannerName('')
        business?.mobileBanner ? setMobileBannerName(business?.mobileBanner) : setMobileBannerName('')
        business?.logo ? setMainLogoName(business?.logo) : setMainLogoName('')
        business?.favicon ? setFaviconeName(business?.favicon) : setFaviconeName('')
        business?.footerLogo ? setFooterLogoName(business?.footerLogo) : setFooterLogoName('')
        if (business?.copyright) { setCopyrightState(business?.copyright); }
    }, [business]);

    useEffect(() => {

        if (location.pathname === '/dashboard/whiteLabelSettings') {
            setTabState('contactInfo');
            setCurrentLocation(true);
        }
        else {
            setTabState('initialInfo');
        }
        if (business) {
            setBusinessId(business?.id);
            if (business?.id !== businessId)
                setStyles(null);
            if (business?.styles && !!!Styles) {
                setStyles(business?.styles);
            }
            form.setFieldsValue({
                title: business?.title ? business?.title : business?.name,
                ...business,
                ...Styles
            });

        }
    }, [business, form, location.pathname, businessId])

    useEffect(() => {
    }, [business])

    const changeName = (fileName, subject) => {
        let re = /(?:\.([^.]+))?$/;
        let ext = re.exec(fileName);
        return `${subject}${Date.now()}.${ext[1]}`
    }

    const handleChange = async (e, subject) => {
        const acceptedTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/webp', 'image/gif', 'image/svg+xml', "image/tiff", 'image/x-icon'];

        if (e) {
            const newName = changeName(e.target.files[0].name, subject);
            const file = e.target.files[0];

            if (!acceptedTypes.includes(file.type)) {
                e.target.value = '';
                message.error('لطفاً یک فایل تصویری انتخاب نمایید.');
                return false;
            }

            const validationResult = await validateUploadedFile(file);
            if (!validationResult.isValid) {
                e.target.value = '';
                message.error(`فایل حاوی محتوای غیرمجاز است`);
                return false;
            }

            // Store file preview
            const reader = new FileReader();
            reader.onload = (event) => {
                setPendingUpload({
                    file: file,
                    subject: subject,
                    newName: newName,
                    preview: event.target.result,
                    e: e
                });
                setIsConfirmModalVisible(true);
            };
            reader.readAsDataURL(file);
        }
    }

    const processPendingUpload = async (confirmed) => {
        if (!confirmed || !pendingUpload) {
            // Decline: reset file input and clear pending upload
            if (pendingUpload?.e) {
                pendingUpload.e.target.value = '';
            }
            setPendingUpload(null);
            setIsConfirmModalVisible(false);
            return;
        }

        // Accept: process the upload
        setUploadLoading(true);
        const { file, subject, newName, e } = pendingUpload;

        try {
            switch (subject) {
                case 'background':
                    const backgroundSize = file.size / 1024 < 100;
                    if (!backgroundSize) {
                        message.error('حداکثر حجم مجاز فایل 100 کیلو بایت است.');
                        return;
                    }
                    const formData1 = new FormData();
                    formData1.append(file.name, file);
                    await axios({
                        method: "post",
                        baseURL: config.apiUrls(),
                        url: `/v1/business/image/business-background/${business?.token}`,
                        headers: { Authorization: `Bearer ${userToken}`, "Content-Type": "multipart/form-data" },
                        data: formData1,
                    }).then(async (res) => {
                        if (res) {
                            setBackgroundName(res.data.Url);
                            message.success(`با موفقیت بارگذاری شد`);
                            await putBusiness({ background: res.data.Url, id: business?.id, domain: business?.domain });
                        }
                    }).catch((error) => {
                        message.error(`خطا در بارگذاری فایل`);
                    })
                    break;
                case 'desktop':
                    const desktopSize = file.size / 1024 < 60;
                    if (!desktopSize) {
                        message.error('حداکثر حجم مجاز فایل 60 کیلو بایت است.');
                        return;
                    }
                    FileServices.uploadFile(file, newName, subject, business?.token).then(async (res) => {
                        if (res) {
                            setDesktopBannerName(res.data.path);
                            (NotifSuccess('فایل با موفقیت آپدیت شد.'))
                            await putBusiness({ desktopBanner: res.data.Url, id: business?.id, domain: business?.domain });
                        }

                    }).catch(error => {
                        message.error('خطا در بارگذاری فایل');
                    })
                    break;
                case 'tablet':
                    const tabletSize = file.size / 1024 < 50;
                    if (!tabletSize) {
                        message.error('حداکثر حجم مجاز فایل 50 کیلو بایت است.');
                        return;
                    }
                    FileServices.uploadFile(file, newName, subject, business?.token).then(async (res) => {
                        if (res) {
                            setTabletBannerName(res.data.path);
                            (NotifSuccess('فایل با موفقیت آپدیت شد.'))
                            await putBusiness({ tabletBanner: res.data.Url, id: business?.id, domain: business?.domain });
                        }
                    }).catch(error => {
                        message.error('خطا در بارگذاری فایل');
                    })
                    break;
                case 'mobile':
                    const mobileSize = file.size / 1024 < 40;
                    if (!mobileSize) {
                        message.error('حداکثر حجم مجاز فایل 40 کیلو بایت است.');
                        return;
                    }
                    FileServices.uploadFile(file, newName, subject, business?.token).then(async (res) => {
                        if (res) {
                            setMobileBannerName(res.data.path);
                            (NotifSuccess('فایل با موفقیت آپدیت شد.'))
                            await putBusiness({ mobileBanner: res.data.Url, id: business?.id, domain: business?.domain });
                        }
                    }).catch(error => {
                        message.error('خطا در بارگذاری فایل');
                    })
                    break;
                case 'footerLogo':
                    const footerLogoSize = file.size / 1024 < 20;
                    if (!footerLogoSize) {
                        message.error('حداکثر حجم مجاز فایل 20 کیلو بایت است.');
                        return;
                    }
                    const formData2 = new FormData();
                    formData2.append(file.name, file);
                    await axios({
                        method: "post",
                        baseURL: config.apiUrls(),
                        url: `/v1/business/image/business-footerlogo/${business?.token}`,
                        headers: { Authorization: `Bearer ${userToken}`, "Content-Type": "multipart/form-data" },
                        data: formData2,
                    }).then(async (res) => {
                        if (res) {
                            setFooterLogoName(res.data.Url);
                            message.success(`با موفقیت بارگذاری شد`);
                            await putBusiness({ footerLogo: res.data.Url, id: business?.id, domain: business?.domain });
                        }
                    }).catch((error) => {
                        message.error(error?.message ?? `خطا در بارگذاری فایل`);
                    })
                    break;
                case 'mainlogo':
                    const mainlogoSize = file.size / 1024 < 10;
                    if (!mainlogoSize) {
                        message.error('حداکثر حجم مجاز فایل ۱۰ کیلو بایت است.');
                        return;
                    }
                    const formData3 = new FormData();
                    formData3.append(file.name, file);
                    await axios({
                        method: "post",
                        baseURL: config.apiUrls(),
                        url: `/v1/business/image/business-logo/${business?.token}`,
                        headers: { Authorization: `Bearer ${userToken}`, "Content-Type": "multipart/form-data" },
                        data: formData3,
                    }).then(async (res) => {
                        if (res) {
                            setMainLogoName(res?.data?.Url);
                            await putBusiness({ logo: res.data.Url, id: business?.id, domain: business?.domain });
                            message.success(`با موفقیت بارگذاری شد`);
                        }
                    }).catch((error) => {
                        message.error(error?.message ?? `خطا در بارگذاری فایل`);
                    })
                    break;
                case 'favicone':
                    const faviconeSize = file.size / 1024 < 7;
                    if (!faviconeSize) {
                        message.error('حداکثر حجم مجاز فایل 7 کیلو بایت است.');
                        return;
                    }
                    const formData4 = new FormData();
                    formData4.append(file.name, file);
                    await axios({
                        method: "post",
                        baseURL: config.apiUrls(),
                        url: `/v1/business/image/business-favicon/${business?.token}`,
                        headers: { Authorization: `Bearer ${userToken}`, "Content-Type": "multipart/form-data" },
                        data: formData4,
                    }).then(async (res) => {
                        if (res) {
                            setFaviconeName(res?.data?.Url);
                            await putBusiness({ favicon: res.data.Url, id: business?.id, domain: business?.domain });
                            message.success(`با موفقیت بارگذاری شد`);
                        }
                    }).catch((error) => {
                        message.error(error?.message ?? `خطا در بارگذاری فایل`);
                    })
                    break;
                default:
                    break;
            }
        } finally {
            setUploadLoading(false);
            setPendingUpload(null);
            setIsConfirmModalVisible(false);
            if (e) e.target.value = '';
        }
    }

    const handleTabChange = (e) => {
        setTabState(e.key)
    }

    const footerToggleChange = (checked) => {
        if (checked) {
            setHtmlDisable(false)
            setTextDisable(true)
        } else {
            setHtmlDisable(true)
            setTextDisable(false)
        }
    }
    const tabFontSize = {
        fontSize: '16px'
    }
    const layout = {
        labelCol: {
            lg: 3,
            xs: 24
        },
        wrapperCol: {
            lg: 20,
            xs: 24
        }
    }
    const popover = {
        position: 'absolute',
        zIndex: 9
    }
    const cover = {
        position: 'fixed',
        top: '0px',
        right: '0px',
        bottom: '0px',
        left: '0px',
    }
    const styleBannersLinkLayout = {
        labelCol: {
            xs: 24
        },
        wrapperCol: {
            xs: 12
        }
    }
    const styleTabLayout = {
        labelCol: {
            xs: 24
        },
        wrapperCol: {
            xs: 24
        }
    }
    const styleTabCols = {
        md: {
            span: 11,
            offset: 1
        },
        xs: {
            span: 23,
            offset: 1
        }
    }
    const radioLayout = {
        labelCol: {
            lg: 12,
            md: 11,
            xs: 16
        },
        wrapperCol: {
            lg: 12,
            md: 13,
            xs: 8
        }
    }
    const ItemLayoutCols = {
        lg: 12,
        md: 11,
        sm: 24,
        xs: 24
    }

    return (
        <section>
            <div>
                <Tabs
                    defaultActiveKey="1"
                    activeKey={tabId}
                    onChange={onChangeTab}
                    type='card'
                    tabPosition="right"
                >
                    <TabPane tab={<span style={tabFontSize}>تنظیمات</span>} key="1">
                        <BusinessSettings
                            tabId={tabId}
                            copyrightState={copyrightState}
                            setCopyrightState={setCopyrightState}
                            tabState={tabState}
                            handleTabChange={handleTabChange}
                            showInfoItems={showInfoItems}
                            currentLocation={currentLocation}
                            userResources={userResources}
                            ItemLayoutCols={ItemLayoutCols}
                            styleBannersLinkLayout={styleBannersLinkLayout}
                            styleTabLayout={styleTabLayout}
                            aElementDownloadItems={aElementDownloadItems}
                            homeStyleItems={homeStyleItems}
                            alignmentItems={alignmentItems}
                            htmlDisable={htmlDisable}
                            textDisable={textDisable}
                            radioLayout={radioLayout}
                            footerToggleChange={footerToggleChange}
                            bulletOutlineInDesktop={bulletOutlineInDesktop}
                            bulletOutlineInMobile={bulletOutlineInMobile}
                            roundBulletInDesktop={roundBulletInDesktop}
                            bulletTextOutInDesktop={bulletTextOutInDesktop}
                            bulletTextOutInMobile={bulletTextOutInMobile}
                            roundBulletInMobile={roundBulletInMobile}
                            setRoundBulletInDesktop={setRoundBulletInDesktop}
                            setBulletTextOutInDesktop={setBulletTextOutInDesktop}
                            setBulletOutlineInDesktop={setBulletOutlineInDesktop}
                            setBulletOutlineInMobile={setBulletOutlineInMobile}
                            setRoundBulletInMobile={setRoundBulletInMobile}
                            setBulletTextOutInMobile={setBulletTextOutInMobile}
                            layout={layout}
                        />
                    </TabPane>

                    <TabPane tab={<span style={tabFontSize}>آپلودها</span>} key="2">
                        <BusinessUploads
                            ItemLayoutCols={ItemLayoutCols}
                            tabId={tabId}
                            styleTabLayout={styleTabLayout}
                            mainLogoName={mainLogoName}
                            faviconeName={faviconeName}
                            backgroundName={backgroundName}
                            hasDefaultSlider={hasDefaultSlider}
                            setHasDefaultSlider={setHasDefaultSlider}
                            handleChange={handleChange}
                            deleteMainFiles={deleteMainFiles}
                            setBackgroundName={setBackgroundName}
                            desktopBannerName={desktopBannerName}
                            deleteBannerFiles={deleteBannerFiles}
                            setDesktopBannerName={setDesktopBannerName}
                            tabletBannerName={tabletBannerName}
                            setTabletBannerName={setTabletBannerName}
                            mobileBannerName={mobileBannerName}
                            setMobileBannerName={setMobileBannerName}
                            footerLogoName={footerLogoName}
                            layout={layout}
                        />
                    </TabPane>

                    <TabPane tab={<span style={tabFontSize}>استایل ها</span>} key="3">
                        <BusinessStyles
                            styleTabCols={styleTabCols}
                            tabId={tabId}
                            styleTabLayout={styleTabLayout}
                            Styles={Styles}
                            setStyles={setStyles}
                            ColorPickerStatus={ColorPickerStatus}
                            setColorPickerStatus={setColorPickerStatus}
                            popover={popover}
                            cover={cover}
                            layout={layout}
                        />
                    </TabPane>
                </Tabs>
            </div>

            {/* Upload Confirmation Modal */}
            <Modal
                title="تایید آپلود فایل"
                open={isConfirmModalVisible}
                onCancel={() => processPendingUpload(false)}
                footer={null}
                centered
                width={500}
            // bodyStyle={{ textAlign: 'center' }}
            >
                {pendingUpload?.preview && (
                    <div style={{ marginBottom: '20px' }}>
                        <img
                            src={pendingUpload.preview}
                            alt="preview"
                            style={{ maxWidth: '100%', maxHeight: '300px', objectFit: 'contain' }}
                        />
                    </div>
                )}
                <p style={{ fontSize: '16px', marginBottom: '30px' }}>
                    آیا مطمئن هستید که می‌خواهید این فایل را آپلود کنید؟
                </p>
                <Space style={{ gap: '10px' }}>
                    <Button
                        type="primary"
                        onClick={() => processPendingUpload(true)}
                        loading={uploadLoading}
                        style={{ width: '120px' }}
                    >
                        تایید
                    </Button>
                    <Button
                        onClick={() => processPendingUpload(false)}
                        style={{ width: '120px' }}
                    >
                        انصراف
                    </Button>
                </Space>
            </Modal>
            <div>
            </div>
        </section>
    )
}